import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3b046e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-center speed-config-container" }
const _hoisted_2 = {
  class: "form-label text-nowrap",
  for: "speed-slider"
}
const _hoisted_3 = { class: "d-flex justify-content-between align-items-center my-3" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "me-2" }
const _hoisted_6 = { class: "based-on" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "game-canvas-container" }, [
  /*#__PURE__*/_createElementVNode("canvas", { id: "game-canvas" })
], -1))
const _hoisted_8 = {
  key: 0,
  class: "warn-pressed-before text-danger fs-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, "Speed: " + _toDisplayString(_ctx.speed), 1),
      _withDirectives(_createElementVNode("input", {
        id: "speed-slider",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.speed) = $event)),
        class: "form-range",
        max: "1000",
        min: "10",
        step: "1",
        type: "range"
      }, null, 512), [
        [_vModelText, _ctx.speed]
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, [
          _createTextVNode("Average input lag: "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.inputLagMillisString) + " ms", 1)
        ]),
        _createElementVNode("small", _hoisted_6, " (Based on the last " + _toDisplayString(_ctx.inputLagMillisList.size()) + " inputs) ", 1)
      ]),
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearInputLagMillisList && _ctx.clearInputLagMillisList(...args)))
      }, "Clear (C)")
    ]),
    _hoisted_7,
    (_ctx.warnPressedBefore)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "You pressed too early!"))
      : _createCommentVNode("", true)
  ], 64))
}